async function fetchLocalizedString(text: string) {
	try {
		let response = await fetch(`/api/user/localize/new/${af.article.id}`, {
			body: JSON.stringify({ text }),
			headers: {
				Accept: "application/json; */*",
				"Content-Type": "application/json",
				"X-Requested-With": "XMLHttpRequest",
			},
			method: "POST",
		});

		if (response.ok) {
			return (await response.json()) as string;
		}
	} catch {}

	return text;
}
export function getLocalizedStringAsync(string: undefined | null): undefined | null;
export function getLocalizedStringAsync(string: string): Promise<string>;
export function getLocalizedStringAsync(string: string | undefined | null) {
	if (!string) return string;

	return getLocalizedString(string, true);
}

export function getLocalizedString(string: undefined | null): undefined | null;
export function getLocalizedString(string: string): string;
export function getLocalizedString(string: string, wait: false): string;
export function getLocalizedString(string: string, wait: true): Promise<string>;
export function getLocalizedString(string: undefined | null, wait: true): undefined | null;
export function getLocalizedString(
	string: string | undefined | null,
	wait?: boolean,
): string | undefined | null | Promise<string> {
	if (typeof string === "string" && string.trim().length === 0) {
		return string;
	}

	if (string === undefined || string === "" || string === null) {
		return;
	}

	if (globalThis.af?.article?.i18n !== undefined) {
		if (!Object.hasOwn(af.article.i18n, string)) {
			af.article.i18n[string] = string;

			let promise = fetchLocalizedString(string).then((text) => {
				af.article.i18n[string] = text;
				return text;
			});

			if (wait) {
				return promise;
			}
		}

		return af.article.i18n[string];
	} else {
		return string;
	}
}
